module.exports = __webpack_public_path__ + "static/media/headingGraphics.661a6e61.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Heading/headingGraphics.svg
// module id = 109
// module chunks = 0